import { render, staticRenderFns } from "./AffiliateIndex.vue?vue&type=template&id=888ad214"
import script from "./AffiliateIndex.vue?vue&type=script&lang=js"
export * from "./AffiliateIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports